import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { PaginatedResponse } from '../../types';

interface PaginationProps<T> {
  meta: Pick<PaginatedResponse<T>, 'current_page' | 'last_page' | 'total'>;
  onPageChange: (page: number) => void;
}

export function Pagination<T>({ meta, onPageChange }: PaginationProps<T>) {
  if (meta.last_page <= 1) return null;

  return (
    <div className="flex items-center justify-between px-1 py-3 text-sm">
      <p className="text-onSurface-mute">
        Página {meta.current_page} de {meta.last_page} · {meta.total} resultados
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(meta.current_page - 1)}
          disabled={meta.current_page <= 1}
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg border border-outlineVarWarm text-onSurface-var hover:bg-surface-dim disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronLeft className="w-4 h-4" /> Anterior
        </button>
        <button
          type="button"
          onClick={() => onPageChange(meta.current_page + 1)}
          disabled={meta.current_page >= meta.last_page}
          className="flex items-center gap-1 px-3 py-1.5 rounded-lg border border-outlineVarWarm text-onSurface-var hover:bg-surface-dim disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          Siguiente <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
